module.exports = __webpack_public_path__ + "img/PK.c2c9a173.png";